module.exports = __webpack_public_path__ + "img/article-image-3.25930801.jpeg";